import axios from "axios";

export interface RiskAnalysisModel {
  id: string;
  companyId: string;
  companyLocationId: string;
  riskAnalysis1: boolean;
  riskAnalysis2: boolean;
  riskAnalysis3: boolean;
  riskAnalysis4: boolean;
  riskAnalysis5: boolean;
  riskAnalysis6: boolean;
  riskAnalysis7: boolean;
  riskAnalysis8: boolean;
  riskAnalysis9: boolean;
  riskAnalysis10: boolean;
  riskAnalysis11: boolean;
  riskAnalysis12: boolean;
  riskAnalysis13: boolean;
  riskAnalysis14: boolean;
  riskAnalysis15: boolean;
  riskAnalysis16: boolean;
  riskAnalysis17: boolean;
  riskAnalysis18: boolean;
  riskAnalysis19: boolean;
  riskAnalysis20: boolean;
  riskAnalysis21: boolean;
  riskAnalysis22: boolean;
  riskAnalysis23: boolean;
  riskAnalysis24: boolean;
  riskAnalysis25: boolean;
  riskAnalysis26: boolean;
  riskAnalysis27: boolean;
  riskAnalysis28: boolean;
  riskAnalysis29: boolean;
  riskAnalysis30: boolean;
  riskAnalysis31: boolean;
  riskAnalysis32: boolean;
  riskAnalysis33: boolean;
  riskAnalysis34: boolean;
  riskAnalysis35: boolean;
  riskAnalysis36: boolean;
  riskAnalysis37: boolean;
  riskAnalysis38: boolean;
  riskAnalysis39: boolean;
  riskAnalysis40: boolean;
  riskAnalysis41: boolean;
  riskAnalysis42: boolean;
  riskAnalysis43: boolean;
  riskAnalysis44: boolean;
  riskAnalysis45: boolean;
  riskAnalysis46: boolean;
  riskAnalysis47: boolean;
  riskAnalysis48: boolean;
}

export async function getRiskAnalysisByLocationId(locationId: string) {
  return axios
    .get<RiskAnalysisModel>(`RiskAnalysises/getriskanalysisebylocationid`, {
      params: { id: locationId },
    })
    .then((res) => res.data);
}

export async function updateRiskAnalysis(data: RiskAnalysisModel) {
  return axios
    .put("RiskAnalysises/updateriskanalysise", data)
    .then((res) => res.data);
}

export const riskAnalysisTableMap: Record<string, string> = {
  riskAnalysis1: "Varemodtagelse",
  riskAnalysis2: "Varemodtagelse",
  riskAnalysis3: "Varemodtagelse",
  riskAnalysis4: "Varemodtagelse",
  riskAnalysis5: "Varemodtagelse",
  riskAnalysis6: "Varemodtagelse",
  riskAnalysis7: "Varemodtagelse",
  riskAnalysis8: "Varemodtagelse",
  riskAnalysis9: "Varemodtagelse",
  riskAnalysis10: "Varemodtagelse",
  riskAnalysis11: "Varemodtagelse",
  riskAnalysis12: "Varemodtagelse",
  riskAnalysis13: "Varemodtagelse",
  riskAnalysis14: "Varemodtagelse",
  riskAnalysis15: "Varemodtagelse",
  riskAnalysis16: "Varemodtagelse",
  riskAnalysis17: "Adskillelse - Opbevaring",
  riskAnalysis18: "Adskillelse - Opbevaring",
  riskAnalysis19: "Adskillelse - Opbevaring",
  riskAnalysis20: "Adskillelse - Opbevaring",
  riskAnalysis21: "Adskillelse - Opbevaring",
  riskAnalysis22: "Temperatur på køl og frost - Opbevaring",
  riskAnalysis23: "Temperatur på køl og frost - Opbevaring",
  riskAnalysis24: "Temperatur på køl og frost - Opbevaring",
  riskAnalysis25: "Temperatur på køl og frost - Opbevaring",
  riskAnalysis26: "Temperatur på køl og frost - Opbevaring",
  riskAnalysis27: "Temperatur på køl og frost - Opbevaring",
  riskAnalysis28: "Temperatur på køl og frost - Opbevaring",
  riskAnalysis29: "Temperatur på køl og frost - Opbevaring",
  riskAnalysis30: "Temperatur på køl og frost - Opbevaring",
  riskAnalysis31: "Holdbarhed",
  riskAnalysis32: "Håndtering af varer og produktion",
  riskAnalysis33: "Holdbarhed",
  riskAnalysis34: "Holdbarhed",
  riskAnalysis35: "Holdbarhed",
  riskAnalysis36: "Holdbarhed",
  riskAnalysis37: "Holdbarhed",
  riskAnalysis38: "Håndtering af varer og produktion",
  riskAnalysis39: "Håndtering af varer og produktion",
  riskAnalysis40: "Håndtering af varer og produktion",
  riskAnalysis41: "Håndtering af varer og produktion",
  riskAnalysis42: "Håndtering af varer og produktion",
  riskAnalysis43: "Håndtering af varer og produktion",
  riskAnalysis44: "Håndtering af varer og produktion",
  riskAnalysis45: "Håndtering af varer og produktion",
  riskAnalysis46: "Håndtering af varer og produktion",
  riskAnalysis47: "Håndtering af varer og produktion",
  riskAnalysis48: "Håndtering af varer og produktion",
  riskAnalysis49: "Håndtering af varer og produktion",
  riskAnalysis50: "Håndtering af varer og produktion",
  riskAnalysis51: "Håndtering af varer og produktion",
  riskAnalysis52: "Håndtering af varer og produktion",
  riskAnalysis53: "Håndtering af varer og produktion",
  riskAnalysis54: "Håndtering af varer og produktion",
  riskAnalysis55: "Håndtering af varer og produktion",
  riskAnalysis56: "Håndtering af varer og produktion",
  riskAnalysis57: "Håndtering af varer og produktion",
  riskAnalysis58: "Håndtering af varer og produktion",
  riskAnalysis59: "Håndtering af varer og produktion",
  riskAnalysis60: "Håndtering af varer og produktion",
  riskAnalysis61: "Håndtering af varer og produktion",
  riskAnalysis62: "Håndtering af varer og produktion",
  riskAnalysis63: "Håndtering af varer og produktion",
  riskAnalysis64: "Håndtering af varer og produktion",
  riskAnalysis65: "Håndtering af varer og produktion",
  riskAnalysis66: "Håndtering af varer og produktion",
  riskAnalysis67: "Håndtering af varer og produktion",
  riskAnalysis68: "Håndtering af varer og produktion",
  riskAnalysis69: "Håndtering af varer og produktion",
  riskAnalysis70: "Håndtering af varer og produktion",
  riskAnalysis71: "Håndtering af varer og produktion",
  riskAnalysis72: "Håndtering af varer og produktion",
  riskAnalysis73: "Håndtering af varer og produktion",
  riskAnalysis74: "Håndtering af varer og produktion",
  riskAnalysis75: "Håndtering af varer og produktion",
  riskAnalysis76: "Håndtering af varer og produktion",
  riskAnalysis77: "Håndtering af varer og produktion",
  riskAnalysis78: "Håndtering af varer og produktion",
  riskAnalysis79: "Håndtering af varer og produktion",
  riskAnalysis80: "Håndtering af varer og produktion",
  riskAnalysis81: "Håndtering af varer og produktion",
  riskAnalysis82: "Håndtering af varer og produktion",
  riskAnalysis83: "Håndtering af varer og produktion",
  riskAnalysis84: "Håndtering af varer og produktion",
  riskAnalysis85: "Håndtering af varer og produktion",
  riskAnalysis86: "Håndtering af varer og produktion",
  riskAnalysis87: "Håndtering af varer og produktion",
  riskAnalysis88: "Håndtering af varer og produktion",
  riskAnalysis89: "Mærkning - Allergener",
  riskAnalysis90: "Mærkning - Allergener",
  riskAnalysis91: "Mærkning - Allergener",
  riskAnalysis92: "Mærkning - Allergener",
  riskAnalysis93: "Rengøring og Hygiejene",
  riskAnalysis94: "Rengøring og Hygiejene",
  riskAnalysis95: "Rengøring og Hygiejene",
  riskAnalysis96: "Rengøring og Hygiejene",
  riskAnalysis97: "Rengøring og Hygiejene",
  riskAnalysis98: "Rengøring og Hygiejene",
  riskAnalysis99: "Rengøring og Hygiejene",
  riskAnalysis100: "Rengøring og Hygiejene",
  riskAnalysis101: "Håndtering af affald",
  riskAnalysis102: "Sporbarehd og tilbagetræning",
  riskAnalysis103: "Sporbarehd og tilbagetræning",
  riskAnalysis104: "Sporbarehd og tilbagetræning",
  riskAnalysis105: "Sporbarehd og tilbagetræning",
  riskAnalysis106: "Sporbarehd og tilbagetræning",
  riskAnalysis107: "Sporbarehd og tilbagetræning",
  riskAnalysis108: "Vedligeholdelse og skadedyrssikring",
  riskAnalysis109: "Vedligeholdelse og skadedyrssikring",
  riskAnalysis110: "Vedligeholdelse og skadedyrssikring",
  riskAnalysis111: "Vedligeholdelse og skadedyrssikring",
};
